import { configure } from "vee-validate"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(() => {
  const config = {
    // mode: "eager", //Is a combination of aggressive and lazy - seems not working perfectly
    classes: {
      valid: "is-valid",
      invalid: "is-invalid"
    }
  }

  configure(config)
})
